import React from "react";
import BarekamText from "../../../../../../components/text";
import {Message, MessageSections} from "../../../../../../components/message/message";
import {BarekamSelect} from "../../../../../../components/select/select";
import {PaymentTypeModel} from "../../../../../../shared/models/order/payment-type.model";
import {MenuItem} from "@mui/material";

const PaymentTypeFilter = (props: PaymentTypeFilterProps) => {
    const {selectedFilterId, onFilterChange, paymentTypes} = props;

    return (
        <BarekamSelect
            variant={'outlined'}
            label={<Message messageKey={'payment_type'} sectionId={MessageSections.ORDERS}/>}
            value={selectedFilterId || 'all'}
            type={"filter"}
            fullWidth
            required>
            <MenuItem onClick={() => onFilterChange(undefined)}
                            value={'all'}
                            key={'all'}>
                <BarekamText variant={"m"}>
                    <Message messageKey={"all"} sectionId={MessageSections.ORDERS}/>
                </BarekamText>
            </MenuItem>
            {

                paymentTypes.map(paymentType =>
                    <MenuItem onClick={() => onFilterChange(paymentType)}
                                    value={paymentType.paymentTypeId}
                                    key={paymentType.paymentTypeId}>
                        <BarekamText variant={"m"}>
                            <Message messageKey={paymentType.name} sectionId={MessageSections.ORDERS}/>
                        </BarekamText>
                    </MenuItem>
                )
            }
        </BarekamSelect>
    );
};

export default PaymentTypeFilter;

interface PaymentTypeFilterProps {
    selectedFilterId: number | undefined;
    paymentTypes: PaymentTypeModel[];
    onFilterChange: (filter: PaymentTypeModel | undefined) => void
}